import React from "react";
import { Link } from 'react-router-dom';

import moment from "moment"
import { db } from "firebase/fbConfig.js"
import Button from "components/CustomButtons/Button.jsx";

export const formatCustomers = (snapshot, test = false) => {
    return snapshot.docs.map(doc => {


        const commaFy = (dollarValue) => dollarValue.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        const numberfyString = (string) => string.replace(/[$,]+/g, "")
        const dateFormat = (fsDate) => fsDate ? moment(fsDate.toDate()).format('YYYY-MM-DD hh:MM') : 'N/A'

        const docData = {
            ...doc.data(),
            id: doc.id
        }

        let currentTotal = 0
        let pastDue1Total = 0
        let pastDue31Total = 0
        let pastDue61Total = 0 
        let pastDue91Total = 0


        docData.invoices.map((invoice) => {
            console.log(invoice.status)

            let agingStatus

            if (invoice.status != "Paid" || invoice.status != "Paid in Full") {
                if (invoice.invoice) {
                    let timeAged = new Date().getTime() - new Date(invoice.invoice.createdAt.seconds * 1000).getTime()
                    let daysAged = Math.round(timeAged / (1000 * 3600 * 24))
                    switch (true) {
                      case (daysAged < 31):
                        agingStatus = "Current";
                        currentTotal += Number(invoice.invoice.amount)
                        break;
                      case (daysAged < 61):
                        agingStatus = "Past Due 1 - 30 Days";
                        pastDue1Total += Number(invoice.invoice.amount)
                        break;
                      case (daysAged < 91):
                        agingStatus = "Past Due 31 - 60 Days";
                        pastDue31Total += Number(invoice.invoice.amount)
                        break;
                      case (daysAged < 121):
                        agingStatus = "Past Due 61 - 90 Days";
                        pastDue61Total += Number(invoice.invoice.amount)
                        break;
                      case (daysAged >= 121):
                        agingStatus = "Past Due > 90 Days";
                        pastDue91Total += Number(invoice.invoice.amount)
                    }
                }
            }
            
            console.log(agingStatus)
        })

                console.log(currentTotal, pastDue1Total, pastDue31Total, pastDue61Total, pastDue91Total)


    //     let shipperID = doc.id
    //     let shipperName = docData.name



    //     let orders

    //     let orderData = await db.collection("haney-orders").where('entityIDs', 'array-contains', doc.id)
    //   .get().then((snapshot) => {
    //     const data = []
    //     // Parse data into array like in firebase.js
    //     snapshot.forEach(async (doc) => {
    //       var docData = doc.data()
    //       var docObj = {
    //         invoice: docData.docs ? (docData.docs["invoice"] ? docData.docs["invoice"] : "") : "",
    //         status: docData.financialStatus ? docData.financialStatus : "",
    //       }
    //       data.push(docObj);

    //     })
    //     // console.log(data)
    //     orders = data
    //     return (data)
    //   }, (error) => {
    //     console.log('error fetching data: ', error)
    //   })
    //         await db.collection('haney-shippers-invoices-3').doc(shipperID).set({
    //             name: shipperName ? shipperName : "",
    //             city: (docData.physicalCity ? docData.physicalCity  : "") + ", " + (docData.physicalState ? docData.physicalState  : ""),
    //             id: shipperID ? shipperID : "",
    //             invoices: orders ? orders : ""
    //         }, { merge: true })

    //   console.log(orders)

        return {
            ...docData,
            actions: (
                <Link to={{
                    pathname: `/shipper/${doc.id}`,
                    state: {
                        shipperID: doc.id,
                        status: docData.status
                    }
                }}>
                    <Button
                        color="primary"
                        fullWidth
                    >DETAILS</Button>
                </Link>
            ),
            name: docData.name ? docData.name.toString() : 'N/A',
            city: docData.city ? docData.city.toString() : 'N/A',
            currentTotal: currentTotal ? ("$" + currentTotal.toFixed(2)) : 0,
            pastDue1Total: pastDue1Total ? ("$" + pastDue1Total.toFixed(2)) : 0,
            pastDue31Total: pastDue31Total ? ("$" + pastDue31Total.toFixed(2)) : 0,
            pastDue61Total: pastDue61Total ? ("$" + pastDue61Total.toFixed(2)) : 0,
            pastDue91Total: pastDue91Total ? ("$" + pastDue91Total.toFixed(2)) : 0
            // pickUpBy: (
            //     <p>{dateFormat(docData.pickUpBy)}</p>
            // ),
            // dropOffBy: (
            //     <p>{dateFormat(docData.dropOffBy)}</p>
            // ),
            // completeDate: <p>{dateFormat(docData.completeDate)}</p>,
            // totalRevenue: commaFy(revenue),
            // totalExpenses: commaFy(expenses),
            // cmTotal: commaFy(cmTotal),
            // cmPercent,
            // invoiceCount: invoiceCount,
            // totalDisbursement: commaFy(revenue) * .02,
            // totalFactoringFees: commaFy(revenue) - (commaFy(revenue) * .02)
        }
    });
}

export const getCustomers = (type = undefined, limited = true) => new Promise((resolve, reject) => {
    let ref = db.collection('haney-shippers-invoices-3');

    // console.log(type)

    // if (type) ref = ref.where('tripType', '==', type);

    // ref = ref.orderBy('tripNumber', 'desc')

    // if (limited) ref = ref.limit(1000);

    ref.get()
        .then(resolve)
        .catch(reject);
})


// WEBPACK FOOTER //
// ./src/tables/rows/customers.js